import { AttachFileRounded } from '@mui/icons-material'
import { Box, Divider, Tooltip, Typography } from '@mui/material'

import { GridCellExpand } from '@rest/UI/components/cells'

export default function EventListCommentsCell({
  mobileView,
  params,
  attachmentsEnabled,
  setAttachmentsModalData,
}) {
  const attachments = params.row.smokeFeedback?.attachments ?? []
  return mobileView ? (
    <Box display="flex" flexDirection="column" alignItems="end">
      {!!attachments.length && attachmentsEnabled && (
        <>
          <Typography
            variant="caption"
            onClick={() => setAttachmentsModalData(attachments)}
            sx={{
              color: 'primary.main',
              cursor: 'pointer',
              textDecoration: 'underline',
            }}
          >{`${attachments.length} file${
            attachments.length > 1 ? 's' : ''
          }`}</Typography>
          <Divider sx={{ height: '1px', width: 1, my: 0.5 }} />
        </>
      )}
      <Typography variant="caption" textAlign="end">
        {params.formattedValue}
      </Typography>
    </Box>
  ) : (
    <Box
      display="flex"
      width={1}
      alignItems="center"
      gap={1}
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
    >
      {!!attachments.length && attachmentsEnabled && (
        <Tooltip
          title={`${attachments.length} file${attachments.length > 1 ? 's' : ''}`}
        >
          <AttachFileRounded
            onClick={() => setAttachmentsModalData(attachments)}
            sx={{ fontSize: 16, cursor: 'pointer' }}
          />
        </Tooltip>
      )}
      <GridCellExpand {...params} />
    </Box>
  )
}
